import { ChartFilter } from "generated-sources";

export const [DATE_PART_TO_QUERY_STRING, DATE_PART_FROM_QUERY_STRING] = Object.keys(ChartFilter.DateFilterPart).reduce((acc, datePart) => {
    const shortcut = datePart.toLowerCase().replace(/_/g, '');
    return [
        { ...acc[0], [datePart as ChartFilter.DateFilterPart]: shortcut },
        { ...acc[1], [shortcut]: datePart as ChartFilter.DateFilterPart }
    ];
}, [{}, {}] as [Record<ChartFilter.DateFilterPart, string>, Record<string, ChartFilter.DateFilterPart>]);
